import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import AddButton from "../../../Componets/Buttons/add";
import DotIcon from "../../../Assets/Svg/dot";
import { FormOutlined, PrinterOutlined } from "@ant-design/icons";
import AreaChart from "../../../Componets/Areachart";
import Barchart from "../../../Componets/Barchart";
import SalesIcon from "../../../Assets/Svg/sales";
import PurchaseIcon from "../../../Assets/Svg/purchase";
import ProductIcon from "../../../Assets/Svg/products";
import InventoryIcon from "../../../Assets/Svg/inventory";
import Piechart from "../../../Componets/Piechart";
import billing from "../../../Data/billing.json";
import Header from "../../../Componets/Header";
import headers from "../../../Data/Tables/Dashboard/Dashboard/headers";
import { get_dashboard } from "../../../Controllers/Dashboard/Dashboard";
import moment from "moment";
import toast from "react-hot-toast";
import Loadercomponent from "../../../Componets/Loader";
import CustomerIcon from "../../../Assets/Svg/customer";
import Status from "../../../Componets/Status";
import { Button } from "antd";
import SupplierIcon from "../../../Assets/Svg/supplier";
import ReactToPrint from "react-to-print";
import ScrollWrapper from "../../../Componets/ScrollWrapper";
import formatDateDDMMYYYY from "../../../Main/formatDate";
import { get_all_invoices } from "../../../Controllers/Sales/Invoices";
import { get_all_sales_returns } from "../../../Controllers/Sales/Returns";

const Dashboard = () => {
  let componentRef = useRef();
  const salesReportRef = useRef();

  let navigate = useNavigate();
  const [header, setHeader] = useState(headers);
  const [branch_info, setBranch_info] = useState();

  const formdata = (data) => {
    console.log("data", data);
    localStorage.setItem("Dashboard_Branch", data.branch ? data.branch : "");
    fetchData(data);
    fetchDatas(data);
  };

  const [loader, setLoader] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [body, setBody] = useState();

  const [cards, setCards] = useState([
    {
      icon: <ProductIcon width={40} height={40} />,
      label: "Total Products",
      path: "/app/dashboard/products",
      value: "0",
      color: "bg-blue-600",
      textcolor: "text-white",
    },
    {
      icon: <ProductIcon width={40} height={40} />,
      label: "Low Stock",
      path: "/app/dashboard/lowstock",
      value: "0",
      color: "bg-orange-600",
      textcolor: "text-white",
    },
    {
      icon: <ProductIcon width={40} height={40} />,
      label: "Out Of Stock",
      path: "/app/dashboard/outofstock",
      value: "0",
      color: "bg-red-600",
      textcolor: "text-white",
    },
  ]);

  const [cards1, setCards1] = useState([
    {
      icon: <InventoryIcon width={40} height={40} />,
      label: "Total Inventories",
      path: "/app/dashboard/inventory",
      value: "0",
      color: "bg-violet-600",
      textcolor: "text-white",
    },
    {
      icon: <InventoryIcon width={40} height={40} />,
      label: "Near Expiry",
      path: "/app/dashboard/inventorynearexpiry",
      value: "0",
      color: "bg-amber-600",
      textcolor: "text-white",
    },
    {
      icon: <InventoryIcon width={40} height={40} />,
      label: "Expired",
      path: "/app/dashboard/inventoryexpiry",
      value: "0",
      color: "bg-pink-600",
      textcolor: "text-white",
    },
  ]);

  const [cards2, setCards2] = useState([
    {
      icon: <SalesIcon width={40} height={40} />,
      path: "/app/dashboard/sales",
      label: "Total Sales",
      value: "0.000",
      color: "bg-green-100 border border-green-200",
      borderColor: "border-b border-green-200",
      textcolor: "text-green-500",
      subtextcolor: "text-green-500 text-sm text-medium pt-2",
    },
    {
      icon: <SalesIcon width={40} height={40} />,
      label: "Total Sales Return",
      path: "/app/dashboard/sales-return",
      value: "0.000",
      color: "bg-orange-100  border border-orange-200",
      borderColor: "border-b border-orange-200",
      textcolor: "text-orange-400",
      subtextcolor: "text-orange-400 text-sm text-medium pt-2",
    },
  ]);

  const [cards3, setCards3] = useState([
    {
      icon: <CustomerIcon width={40} height={40} />,
      label: "Customer Paid",
      value: "0.000",
      color: "bg-green-100 border border-green-200",
      borderColor: "border-b border-green-200",
      textcolor: "text-green-500",
      subtextcolor: "text-green-500 text-sm text-medium pt-2",
    },
    {
      icon: <CustomerIcon width={40} height={40} />,
      label: "Customer Payable",
      value: "0.000",
      color: "bg-green-100 border border-green-200",
      borderColor: "border-b border-green-200",
      textcolor: "text-green-500",
      subtextcolor: "text-green-500 text-sm text-medium pt-2",
    },
  ]);

  const [cards4, setCards4] = useState([
    {
      icon: <CustomerIcon width={40} height={40} />,
      label: "Paid To Customer",
      value: "0.000",
      color: "bg-orange-100  border border-orange-200",
      borderColor: "border-b border-orange-200",
      textcolor: "text-orange-400",
      subtextcolor: "text-orange-400 text-sm text-medium pt-2",
    },
    {
      icon: <CustomerIcon width={40} height={40} />,
      label: "Payable To Customer",
      value: "0.000",
      color: "bg-orange-100  border border-orange-200",
      borderColor: "border-b border-orange-200",
      textcolor: "text-orange-400",
      subtextcolor: "text-orange-400 text-sm text-medium pt-2",
    },
  ]);

  const [cards5, setCards5] = useState([
    {
      icon: <SalesIcon width={40} height={40} />,
      label: "Total Purchases",
      path: "/app/dashboard/purchases",
      value: "0.000",
      color: "bg-indigo-100 border border-indigo-200",
      borderColor: "border-b border-indigo-200",
      textcolor: "text-indigo-500",
      subtextcolor: "text-indigo-500 text-sm text-medium pt-2",
    },
    {
      icon: <SalesIcon width={40} height={40} />,
      label: "Total Purchase Returns",
      path: "/app/dashboard/purchases-returns",
      value: "0.000",
      color: "bg-violet-100  border border-violet-200",
      borderColor: "border-b border-violet-200",
      textcolor: "text-violet-400",
      subtextcolor: "text-violet-400 text-sm text-medium pt-2",
    },
  ]);

  const [cards6, setCards6] = useState([
    {
      icon: <SupplierIcon width={40} height={40} />,
      label: "Paid To Supplier",
      value: "0.000",
      color: "bg-indigo-100 border border-indigo-200",
      borderColor: "border-b border-indigo-200",
      textcolor: "text-indigo-500",
      subtextcolor: "text-indigo-500 text-sm text-medium pt-2",
    },
    {
      icon: <SupplierIcon width={40} height={40} />,
      label: "Payable To Supplier",
      value: "0.000",
      color: "bg-indigo-100 border border-indigo-200",
      borderColor: "border-b border-indigo-200",
      textcolor: "text-indigo-500",
      subtextcolor: "text-indigo-500 text-sm text-medium pt-2",
    },
  ]);

  const [cards7, setCards7] = useState([
    {
      icon: <SupplierIcon width={40} height={40} />,
      label: "Supplier Paid",
      value: "0.000",
      color: "bg-violet-100  border border-violet-200",
      borderColor: "border-b border-violet-200",
      textcolor: "text-violet-400",
      subtextcolor: "text-violet-400 text-sm text-medium pt-2",
    },
    {
      icon: <SupplierIcon width={40} height={40} />,
      label: "Supplier Payable",
      value: "0.000",
      color: "bg-violet-100  border border-violet-200",
      borderColor: "border-b border-violet-200",
      textcolor: "text-violet-400",
      subtextcolor: "text-violet-400 text-sm text-medium pt-2",
    },
  ]);

  const handleData = (dashboard) => {};

  let Dashboard_Branch = localStorage.getItem("Dashboard_Branch");

  const fetchData = async (tabledata) => {
    try {
      setLoader2(true);

      Dashboard_Branch = localStorage.getItem("Dashboard_Branch");

      let data = {
        date: tabledata?.date ? tabledata?.date : "",
        branch: Dashboard_Branch
          ? Dashboard_Branch
          : tabledata?.branch
            ? tabledata?.branch
            : "",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      const dashboard = await get_dashboard(data);

      if (dashboard?.status) {
        setBranch_info(dashboard?.data?.branch_info[0]);
        cards[0].value = dashboard?.data?.total_products
          ? parseFloat(dashboard?.data?.total_products)
          : "0";
        cards[1].value = dashboard?.data?.total_low_stock
          ? parseFloat(dashboard?.data?.total_low_stock)
          : "0";
        cards[2].value = dashboard?.data?.total_out_of_stock
          ? parseFloat(dashboard?.data?.total_out_of_stock)
          : "0";

        cards1[0].value = dashboard?.data?.total_inventories
          ? parseFloat(dashboard?.data?.total_inventories)
          : "0";
        cards1[1].value = dashboard?.data?.total_near_expiry
          ? parseFloat(dashboard?.data?.total_near_expiry)
          : "0";
        cards1[2].value = dashboard?.data?.total_expired
          ? parseFloat(dashboard?.data?.total_expired)
          : "0";

        cards2[0].value = {
          total_sales: dashboard?.data?.total_sales
            ? parseFloat(dashboard?.data?.total_sales)
            : 0,
          total_discount: dashboard?.data?.total_discount
            ? parseFloat(dashboard?.data?.total_discount)
            : 0,
          total_delivery: dashboard?.data?.total_delivery
            ? parseFloat(dashboard?.data?.total_delivery)
            : 0,
          total_cash: dashboard?.data?.total_cash
            ? parseFloat(dashboard?.data?.total_cash)
            : 0,
          total_debit_card: dashboard?.data?.total_debit_card
            ? parseFloat(dashboard?.data?.total_debit_card)
            : 0,
          total_credit_card: dashboard?.data?.total_credit_card
            ? parseFloat(dashboard?.data?.total_credit_card)
            : 0,
          total_bank_transfer: dashboard?.data?.total_bank_transfer
            ? parseFloat(dashboard?.data?.total_bank_transfer)
            : 0,
          total_online_payment: dashboard?.data?.total_online_payment
            ? parseFloat(dashboard?.data?.total_online_payment)
            : 0,
          total_cheque: dashboard?.data?.total_cheque
            ? parseFloat(dashboard?.data?.total_cheque)
            : 0,
        };

        cards2[1].value = {
          total_sales: dashboard?.data?.total_sales_returns
            ? parseFloat(dashboard?.data?.total_sales_returns)
            : 0,
          total_discount: dashboard?.data?.total_sales_returns_discount
            ? parseFloat(dashboard?.data?.total_sales_returns_discount)
            : 0,
          total_delivery: dashboard?.data?.total_sales_returns_delivery
            ? parseFloat(dashboard?.data?.total_sales_returns_delivery)
            : 0,
          total_cash: dashboard?.data?.total_sales_returns_cash
            ? parseFloat(dashboard?.data?.total_sales_returns_cash)
            : 0,
          total_debit_card: dashboard?.data?.total_sales_returns_debit_card
            ? parseFloat(dashboard?.data?.total_sales_returns_debit_card)
            : 0,
          total_credit_card: dashboard?.data?.total_sales_returns_credit_card
            ? parseFloat(dashboard?.data?.total_sales_returns_credit_card)
            : 0,
          total_bank_transfer: dashboard?.data
            ?.total_sales_returns_bank_transfer
            ? parseFloat(dashboard?.data?.total_sales_returns_bank_transfer)
            : 0,
          total_online_payment: dashboard?.data
            ?.total_sales_returns_online_payment
            ? parseFloat(dashboard?.data?.total_sales_returns_online_payment)
            : 0,
          total_cheque: dashboard?.data?.total_sales_returns_cheque
            ? parseFloat(dashboard?.data?.total_sales_returns_cheque)
            : 0,
        };

        cards3[0].value = dashboard?.data?.total_customer_paid
          ? parseFloat(dashboard?.data?.total_customer_paid)
          : 0;
        cards3[1].value = dashboard?.data?.total_customer_payable
          ? parseFloat(dashboard?.data?.total_customer_payable)
          : 0;

        cards4[0].value = dashboard?.data?.total_sales_returns_customer_paid
          ? parseFloat(dashboard?.data?.total_sales_returns_customer_paid)
          : 0;
        cards4[1].value = dashboard?.data?.total_sales_returns_customer_payable
          ? parseFloat(dashboard?.data?.total_sales_returns_customer_payable)
          : 0;

        cards5[0].value = {
          total_sales: dashboard?.data?.total_purchases
            ? parseFloat(dashboard?.data?.total_purchases)
            : 0,
          total_discount: dashboard?.data?.total_purchases_discount
            ? parseFloat(dashboard?.data?.total_purchases_discount)
            : 0,
          total_delivery: dashboard?.data?.total_purchases_delivery
            ? parseFloat(dashboard?.data?.total_purchases_delivery)
            : 0,
          total_cash: dashboard?.data?.total_purchases_cash
            ? parseFloat(dashboard?.data?.total_purchases_cash)
            : 0,
          total_debit_card: dashboard?.data?.total_purchases_debit_card
            ? parseFloat(dashboard?.data?.total_purchases_debit_card)
            : 0,
          total_credit_card: dashboard?.data?.total_purchases_credit_card
            ? parseFloat(dashboard?.data?.total_purchases_credit_card)
            : 0,
          total_bank_transfer: dashboard?.data?.total_purchases_bank_transfer
            ? parseFloat(dashboard?.data?.total_purchases_bank_transfer)
            : 0,
          total_online_payment: dashboard?.data?.total_purchases_online_payment
            ? parseFloat(dashboard?.data?.total_online_purchases_payment)
            : 0,
          total_cheque: dashboard?.data?.total_purchases_cheque
            ? parseFloat(dashboard?.data?.total_purchases_cheque)
            : 0,
        };

        cards5[1].value = {
          total_sales: dashboard?.data?.total_purchase_return
            ? parseFloat(dashboard?.data?.total_purchase_return)
            : 0,
          total_discount: dashboard?.data?.total_purchase_return_discount
            ? parseFloat(dashboard?.data?.total_purchase_return_discount)
            : 0,
          total_delivery: dashboard?.data?.total_purchase_return_delivery
            ? parseFloat(dashboard?.data?.total_purchase_return_delivery)
            : 0,
          total_cash: dashboard?.data?.total_purchase_return_cash
            ? parseFloat(dashboard?.data?.total_purchase_return_cash)
            : 0,
          total_debit_card: dashboard?.data?.total_purchase_return_debit_card
            ? parseFloat(dashboard?.data?.total_purchase_return_debit_card)
            : 0,
          total_credit_card: dashboard?.data?.total_purchase_return_credit_card
            ? parseFloat(dashboard?.data?.total_purchase_return_credit_card)
            : 0,
          total_bank_transfer: dashboard?.data
            ?.total_sales_returns_bank_transfer
            ? parseFloat(dashboard?.data?.total_purchase_return_bank_transfer)
            : 0,
          total_online_payment: dashboard?.data
            ?.total_sales_returns_online_payment
            ? parseFloat(dashboard?.data?.total_purchase_return_online_payment)
            : 0,
          total_cheque: dashboard?.data?.total_purchase_return_cheque
            ? parseFloat(dashboard?.data?.total_purchase_return_cheque)
            : 0,
        };

        cards6[0].value = dashboard?.data?.total_supplier_paid
          ? parseFloat(dashboard?.data?.total_supplier_paid)
          : 0;
        cards6[1].value = dashboard?.data?.total_supplier_payable
          ? parseFloat(dashboard?.data?.total_supplier_payable)
          : 0;

        cards7[0].value = dashboard?.data?.total_purchase_return_supplier_paid
          ? parseFloat(dashboard?.data?.total_purchase_return_supplier_paid)
          : 0;
        cards7[1].value = dashboard?.data
          ?.total_purchase_return_supplier_payable
          ? parseFloat(dashboard?.data?.total_purchase_return_supplier_payable)
          : 0;

        if (dashboard?.data?.role != "SUPERADMIN") {
          header.components[0] = "";
        } else {
          if (
            Array.isArray(dashboard?.data?.branch) &&
            dashboard?.data?.branch?.length > 0
          ) {
            if (!Dashboard_Branch) {
              header.components[0] = {
                type: "filter",
                name: "branch",
                allowClear: true,
                showSearch: true,
                filterOption: false,
                className: "w-80",
                placeholder: "Select a Branch",
                api: "get-all-branches",
                value: dashboard?.data?.branch[0]._id,
                options: dashboard?.data?.branch?.map((b) => {
                  localStorage.setItem("Dashboard_Branch", b._id);
                  return {
                    label:
                      b?.name && b?.phone
                        ? `${b?.name} (${b?.phone})`
                        : b?.name || b?.phone || "",
                    value: b._id,
                  };
                }),
              };
            }
          }
        }

        setHeader(header);
        setCards(cards);
        setCards1(cards1);
        setCards2(cards2);
        setCards3(cards3);
        setCards4(cards4);
        setCards5(cards5);
        setBody(dashboard?.data);
        setLoader2(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
      setLoader2(false);
    }
  };

  useEffect(() => {
    fetchData({
      search: "",
      sort: "",
      customer: "",
      branch: "",
      status: "",
      due_date: "",
      date: {
        start: new Date(),
        end: new Date(),
      },
    });
  }, []);

  const [reportData, setReportData] = useState(null);

  const formatDate = (date) => {
    if (!date) return null;

    if (date.start && date.end) {
      return {
        start: date.start,
        end: date.end,
      };
    }

    if (typeof date.format === "function") {
      const formatted = date.format("YYYY-MM-DD");
      return { start: formatted, end: formatted };
    }

    const d = new Date(date);
    if (!isNaN(d)) {
      const formatted = d.toISOString().split("T")[0];
      return { start: formatted, end: formatted };
    }

    return null;
  };

  const fetchDatas = async (tabledata) => {
    try {
      setLoader(true);

      const data = {
        search: tabledata?.search,
        date: formatDate(tabledata?.date),
        source: "Daily Sales Report",
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      };

      const invoicesData = await get_all_invoices(data);
      const returnData = await get_all_sales_returns(data);

      if (invoicesData?.status && returnData?.status) {
        const activeInvoices = (invoicesData?.data?.data || []).filter(
          (invoice) => invoice?.status === 1,
        );

        processReportData(activeInvoices, returnData?.data?.data || []);
        setLoader(false);
      } else {
        toast?.error(
          invoicesData?.message ||
            returnData?.message ||
            "Failed to fetch data",
        );
        setLoader(false);
      }
    } catch (errors) {
      toast?.error(errors?.message);
    }
  };

  const processReportData = (invoices, salesReturns) => {
    const paymentTotals = {
      sales: {
        cash: 0,
        debit_card: 0,
        bank_transfer: 0,
        credit_card: 0,
        cheque: 0,
        online_payment: 0,
      },
      returns: {
        cash: 0,
        debit_card: 0,
        bank_transfer: 0,
        credit_card: 0,
        cheque: 0,
        online_payment: 0,
      },
    };

    let totalSales = 0;
    let salesVat = 0;
    let salesDiscount = 0;

    console.log("dsiahknsaf", invoices);

    invoices.forEach((invoice) => {
      totalSales += invoice.total || 0;
      salesVat += invoice.taxamount || 0;
      salesDiscount += invoice.discount || 0;

      if (invoice.payments && invoice.payments.length > 0) {
        invoice.payments.forEach((payment) => {
          switch (payment.name?.toLowerCase()) {
            case "cash":
              paymentTotals.sales.cash += payment.amount || 0;
              break;
            case "debit card":
              paymentTotals.sales.debit_card += payment.amount || 0;
              break;
            case "bank transfer":
              paymentTotals.sales.bank_transfer += payment.amount || 0;
              break;
            case "credit card":
              paymentTotals.sales.credit_card += payment.amount || 0;
              break;
            case "cheque":
              paymentTotals.sales.cheque += payment.amount || 0;
              break;
            case "online payment":
              paymentTotals.sales.online_payment += payment.amount || 0;
              break;
          }
        });
      }
    });

    let totalReturns = 0;
    let returnsVat = 0;
    let returnsDiscount = 0;

    salesReturns.forEach((returnItem) => {
      totalReturns += returnItem.total || 0;
      returnsVat += returnItem.taxamount || 0;
      returnsDiscount += returnItem.discount || 0;
      if (returnItem.payments && returnItem.payments.length > 0) {
        returnItem.payments.forEach((payment) => {
          const amount = payment.amount || 0;
          switch (payment.name?.toLowerCase()) {
            case "cash":
              paymentTotals.returns.cash += amount;
              break;
            case "debit card":
              paymentTotals.returns.debit_card += amount;
              break;
            case "bank transfer":
              paymentTotals.returns.bank_transfer += amount;
              break;
            case "credit card":
              paymentTotals.returns.credit_card += amount;
              break;
            case "cheque":
              paymentTotals.returns.cheque += amount;
              break;
            case "online payment":
              paymentTotals.returns.online_payment += amount;
              break;
          }
        });
      }
    });

    const netSales = totalSales - totalReturns;
    const netCash = paymentTotals.sales.cash - paymentTotals.returns.cash;
    const netDebitCard =
      paymentTotals.sales.debit_card - paymentTotals.returns.debit_card;
    const netBankTransfer =
      paymentTotals.sales.bank_transfer - paymentTotals.returns.bank_transfer;
    const netCheque = paymentTotals.sales.cheque - paymentTotals.returns.cheque;
    const netcreditCard =
      paymentTotals.sales.credit_card - paymentTotals.returns.credit_card;
    const netOnlineTranser =
      paymentTotals.sales.online_payment - paymentTotals.returns.online_payment;
    const netVat = salesVat - returnsVat;
    const netDiscount = salesDiscount - returnsDiscount;
    const totalSalesTransactions = invoices.length;
    const totalSalesReturnTransactions = salesReturns.length;
    const totalTransactions = invoices.length + salesReturns.length;

    const currentDate = moment().format("DD-MM-YYYY");
    const currentTime = moment().format("hh:mm A");

    const processedData = {
      date: currentDate,
      time: currentTime,
      pharmacyName: "Suwaig Pharmacy",
      sales: {
        total: totalSales,
        cash: paymentTotals.sales.cash,
        debit_card: paymentTotals.sales.debit_card,
        bank_transfer: paymentTotals.sales.bank_transfer,
        credit_card: paymentTotals.sales.credit_card,
        cheque: paymentTotals.sales.cheque,
        online_payment: paymentTotals.sales.online_payment,
      },
      salesReturn: {
        total: totalReturns,
        cash: paymentTotals.returns.cash,
        debit_card: paymentTotals.returns.debit_card,
        bank_transfer: paymentTotals.returns.bank_transfer,
        credit_card: paymentTotals.returns.credit_card,
        cheque: paymentTotals.returns.cheque,
        online_payment: paymentTotals.returns.online_payment,
      },
      netSales: {
        total: netSales,
        cash: netCash,
        debit_card: netDebitCard,
        bank_transfer: netBankTransfer,
        credit_card: netcreditCard,
        cheque: netCheque,
        online_payment: netOnlineTranser,
      },
      vat: {
        sales: salesVat,
        returns: returnsVat,
        net: netVat,
      },
      discount: {
        sales: salesDiscount,
        returns: returnsDiscount,
        net: netDiscount,
      },
      totalTransactions: {
        sales: totalSalesTransactions,
        returns: totalSalesReturnTransactions,
        total: totalTransactions,
      },
    };

    setReportData(processedData);
  };

  useEffect(() => {
    fetchDatas({
      date: {
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
      },
    });
  }, []);

  return (
    <Header headers={header} setHeaders={setHeader} formdata={formdata}>
      <Loadercomponent loader={loader || loader2}>
        <ScrollWrapper summary={2}>
          <div className="flex justify-between pt-4">
            {cards?.map((value, index) => {
              return (
                <div
                  className={`${value?.color} w-[32%] rounded-md p-6 cursor-pointer`}
                  onClick={() => navigate(value?.path)}
                >
                  <div className="flex justify-between">
                    <div>
                      <div
                        className={`${value?.textcolor} text-4xl text-semi-bold`}
                      >
                        {value?.value}
                      </div>
                      <div className="text-white text-lg pt-2">
                        {value?.label}
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className={`${value?.textcolor} text-2xl`}>
                        {value?.icon}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex justify-between pt-6">
            {cards1?.map((value, index) => {
              return (
                <div
                  className={`${value?.color} w-[32%] rounded-md p-6 cursor-pointer`}
                  onClick={() => navigate(value?.path)}
                >
                  <div className="flex justify-between">
                    <div>
                      <div
                        className={`${value?.textcolor} text-4xl text-semi-bold`}
                      >
                        {value?.value}
                      </div>
                      <div className="text-white text-lg pt-2">
                        {value?.label}
                      </div>
                    </div>
                    <div className="flex items-center">
                      <div className={`${value?.textcolor} text-2xl`}>
                        {value?.icon}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex justify-between pt-6">
            {cards2?.map((value, index) => {
              return (
                <div
                  className={`${value?.color} w-[48%] rounded-md p-6 cursor-pointer`}
                  onClick={() => navigate(value?.path)}
                >
                  <div>
                    <div
                      className={`${value?.borderColor} flex justify-between`}
                    >
                      <div>
                        <div
                          className={`${value?.textcolor} text-4xl text-semi-bold`}
                        >
                          {value?.value?.total_sales?.toFixed?.(3)}
                        </div>
                        <div className={` ${value?.subtextcolor} text-xl`}>
                          {value?.label}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className={`${value?.textcolor} text-2xl`}>
                          {value?.icon}
                        </div>
                      </div>
                    </div>
                    <div className={`${value?.borderColor} py-2`}>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>DISCOUNT</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_discount?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>DELIVERY</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_delivery?.toFixed?.(3)}
                        </div>
                      </div>
                    </div>
                    <div className="pt-3">
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>CASH</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_cash?.toFixed?.(3)}
                        </div>
                      </div>

                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>DEBIT CARD</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_debit_card?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>CREDIT CARD</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_credit_card?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>BANK TRANSFER</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_bank_transfer?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>
                          ONLINE PAYMENT
                        </div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_online_payment?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>CHEQUE</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_cheque?.toFixed?.(3)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex justify-between pt-6">
            <div className="w-[48%]">
              <div className="flex">
                {cards3?.map((value, index) => {
                  return (
                    <div
                      className={!index ? "pr-[1%] w-[50%]" : "pl-[1%] w-[50%]"}
                    >
                      <div className={`${value?.color} rounded-md p-6`}>
                        <div>
                          <div className="flex justify-between">
                            <div>
                              <div
                                className={`${value?.textcolor} text-2xl text-semi-bold`}
                              >
                                {value?.value?.toFixed?.(3)}
                              </div>
                              <div className={`${value?.textcolor} pt-2`}>
                                {value?.label}
                              </div>
                            </div>
                            <div className="flex items-center">
                              <div className={`${value?.textcolor} text-2xl`}>
                                {value?.icon}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="w-[48%]">
              <div className="flex">
                {cards4?.map((value, index) => {
                  return (
                    <div
                      className={!index ? "pr-[1%] w-[50%]" : "pl-[1%] w-[50%]"}
                    >
                      <div className={`${value?.color} rounded-md p-6`}>
                        <div>
                          <div className="flex justify-between">
                            <div>
                              <div
                                className={`${value?.textcolor} text-2xl text-semi-bold`}
                              >
                                {value?.value?.toFixed?.(3)}
                              </div>
                              <div className={`${value?.textcolor} pt-2`}>
                                {value?.label}
                              </div>
                            </div>
                            <div className="flex items-center">
                              <div className={`${value?.textcolor} text-2xl`}>
                                {value?.icon}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="flex justify-between pt-6">
            {cards5?.map((value, index) => {
              return (
                <div
                  className={`${value?.color} w-[48%] rounded-md p-6 cursor-pointer`}
                  onClick={() => navigate(value?.path)}
                >
                  <div>
                    <div
                      className={`${value?.borderColor} flex justify-between`}
                    >
                      <div>
                        <div
                          className={`${value?.textcolor} text-4xl text-semi-bold`}
                        >
                          {value?.value?.total_sales?.toFixed?.(3)}
                        </div>
                        <div className={` ${value?.subtextcolor} text-xl`}>
                          {value?.label}
                        </div>
                      </div>
                      <div className="flex items-center">
                        <div className={`${value?.textcolor} text-2xl`}>
                          {value?.icon}
                        </div>
                      </div>
                    </div>
                    <div className={`${value?.borderColor} py-2`}>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>DISCOUNT</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_discount?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>DELIVERY</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_delivery?.toFixed?.(3)}
                        </div>
                      </div>
                    </div>
                    <div className="pt-3">
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>CASH</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_cash?.toFixed?.(3)}
                        </div>
                      </div>

                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>DEBIT CARD</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_debit_card?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>CREDIT CARD</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_credit_card?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>BANK TRANSFER</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_bank_transfer?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>
                          ONLINE PAYMENT
                        </div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_online_payment?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div className={value?.subtextcolor}>CHEQUE</div>
                        <div className={value?.subtextcolor}>
                          {value?.value?.total_cheque?.toFixed?.(3)}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="flex justify-between pt-6">
            <div className="w-[48%]">
              <div className="flex">
                {cards6?.map((value, index) => {
                  return (
                    <div
                      className={!index ? "pr-[1%] w-[50%]" : "pl-[1%] w-[50%]"}
                    >
                      <div className={`${value?.color} rounded-md p-6`}>
                        <div>
                          <div className="flex justify-between">
                            <div>
                              <div
                                className={`${value?.textcolor} text-2xl text-semi-bold`}
                              >
                                {value?.value?.toFixed?.(3)}
                              </div>
                              <div className={`${value?.textcolor} pt-2`}>
                                {value?.label}
                              </div>
                            </div>
                            <div className="flex items-center">
                              <div className={`${value?.textcolor} text-2xl`}>
                                {value?.icon}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
            <div className="w-[48%]">
              <div className="flex">
                {cards7?.map((value, index) => {
                  return (
                    <div
                      className={!index ? "pr-[1%] w-[50%]" : "pl-[1%] w-[50%]"}
                    >
                      <div className={`${value?.color} rounded-md p-6`}>
                        <div>
                          <div className="flex justify-between">
                            <div>
                              <div
                                className={`${value?.textcolor} text-2xl text-semi-bold`}
                              >
                                {value?.value?.toFixed?.(3)}
                              </div>
                              <div className={`${value?.textcolor} pt-2`}>
                                {value?.label}
                              </div>
                            </div>
                            <div className="flex items-center">
                              <div className={`${value?.textcolor} text-2xl`}>
                                {value?.icon}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          <div className="pt-8 pb-4">
            <div className="">
              <table className="w-full rounded-lg overflow-hidden">
                <thead>
                  <tr className="text-white bg-black border-b">
                    <td className="p-3 first:rounded-tl-lg last:rounded-tr-lg">
                      Invoice
                    </td>
                    <td className="p-3">Date</td>
                    <td className="p-3">Customer</td>
                    <td className="p-3">Created</td>
                    <td className="p-3 text-right first:rounded-tl-lg last:rounded-tr-lg">
                      Amount
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {body?.recent_invoices?.map(
                    (value, index) =>
                      index <= 5 && (
                        <tr
                          className={`hover:bg-gray-200 bg-white border-b ${
                            index === billing?.length - 1
                              ? "last:rounded-bl-lg last:rounded-br-lg border-none"
                              : ""
                          }`}
                          key={index}
                        >
                          <td className="p-3">{`#INV-${value?.number}`}</td>
                          <td className="p-3">
                            {formatDateDDMMYYYY(value?.date)}
                          </td>
                          <td className="p-3">
                            {value?.customer?.name
                              ? value?.customer?.name
                              : "Walk-in-customer"}
                          </td>
                          <td className="p-3">
                            {value?.created_by?.name
                              ? value?.created_by?.name
                              : ""}
                          </td>
                          <td className="p-3 text-right">
                            {parseFloat(value?.total)?.toFixed(3)}
                          </td>
                        </tr>
                      ),
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div className="pt-8 pb-4">
            <div className="">
              <table className="w-full rounded-lg overflow-hidden">
                <thead>
                  <tr className="text-white bg-black border-b">
                    <td className="p-3 first:rounded-tl-lg last:rounded-tr-lg">
                      Rquested
                    </td>
                    <td className="p-3">Date</td>
                    <td className="p-3">Branch</td>
                    <td className="p-3">Created</td>
                    <td className="p-3 text-right first:rounded-tl-lg last:rounded-tr-lg">
                      Status
                    </td>
                  </tr>
                </thead>
                <tbody>
                  {body?.inventory_requestes?.map(
                    (value, index) =>
                      index <= 5 && (
                        <tr
                          className={`hover:bg-gray-200 bg-white border-b ${
                            index === billing?.length - 1
                              ? "last:rounded-bl-lg last:rounded-br-lg border-none"
                              : ""
                          }`}
                          key={index}
                        >
                          <td className="p-3">{`#REQUESTED-${value?.number}`}</td>
                          <td className="p-3">
                            {formatDateDDMMYYYY(value?.date)}
                          </td>
                          <td className="p-3">
                            {value?.branch?.name ? value?.branch?.name : ""}
                          </td>
                          <td className="p-3">
                            {value?.created_by?.name
                              ? value?.created_by?.name
                              : ""}
                          </td>
                          <td className="p-3 text-right">
                            <div className="inline-block">
                              <Status
                                name={
                                  value?.status ? "Not-accepted" : "Accepted"
                                }
                                status={value?.status ? 0 : 1}
                              />
                            </div>
                          </td>
                        </tr>
                      ),
                  )}
                </tbody>
              </table>
            </div>
          </div>

          <div>
            <div className="flex justify-end gap-4">
              <ReactToPrint
                trigger={() => (
                  <Button
                    className="bg-white border rounded hover:border-green-500"
                    type="button"
                    size="large"
                  >
                    Print <PrinterOutlined className="text-lg" />
                  </Button>
                )}
                content={() => componentRef}
              />

              <ReactToPrint
                trigger={() => (
                  <Button
                    className="bg-white border rounded hover:border-blue-500"
                    type="button"
                    size="large"
                  >
                    A5 Print <PrinterOutlined className="text-lg" />
                  </Button>
                )}
                content={() => salesReportRef.current}
              />
            </div>
          </div>

          <div
            ref={salesReportRef}
            className="hidden-on-screen a5-landscape max-w-3xl mx-auto p-6 bg-white text-gray-900 rounded-2xl shadow-md print:shadow-none print:max-w-full print:p-0"
          >
            <style>
              {`
         @media print {
            .a5-landscape {
              width: 20cm;
              height: 12cm;
              margin-top: 0cm;
              margin-left: 0.5cm;
              margin-right: 1cm;
              margin-bottom: 2cm;
            }
            
            .a5-landscape + * {
              display: none !important;
            }
          }
          
          @page a5-landscape {
            size: A5 landscape;
          }
          
          .a5-landscape {
            page: a5-landscape;
          }

          @media print {
                .a5-landscape,
                .a5-landscape * {
                  visibility: visible;
                  font-size: 7pt !important;
                  padding: 2px !important;
                  line-height: 1.2 !important;
                }

                .a5-landscape h1,
                .a5-landscape h4 {
                  font-size: 10pt !important;
                  font-weight: bold;
                }
              }
            `}
            </style>

            <div className="mb-8"></div>
            <div className="mb-16"></div>
            <div className="text-center mb-2">
              <h1 className="text-xl font-bold">
                Daily Sales Report - {branch_info?.name}
              </h1>
              <p className="text-sm">
                {reportData?.date} {reportData?.time}
              </p>
            </div>

            <section className="mb-3">
              <div className="flex justify-between items-center bg-gray-100 p-3 rounded-t">
                <h4 className="font-bold text-lg">SALES</h4>
                <div className="font-bold text-lg text-green-600">
                  {reportData?.sales?.total?.toFixed(3) || 0}
                </div>
              </div>

              <div className="border border-t-0 rounded-b p-3">
                <div className="grid grid-cols-4 gap-4 text-center">
                  <div className="border-r">
                    <div className="font-medium">CASH</div>
                    <div className="text-green-600 font-bold">
                      {reportData?.sales?.cash?.toFixed(3) || 0}
                    </div>
                  </div>
                  <div className="border-r">
                    <div className="font-medium">DEBIT / CREDIT CARD</div>
                    <div className="text-green-600 font-bold">
                      {(
                        reportData?.sales?.debit_card +
                        reportData?.sales?.credit_card
                      )?.toFixed(3) || 0}
                    </div>
                  </div>
                  <div className="border-r">
                    <div className="font-medium">BANK TRANSFER</div>
                    <div className="text-green-600 font-bold">
                      {reportData?.sales?.bank_transfer?.toFixed(3) || 0}
                    </div>
                  </div>
                  {/* <div className="border-r">
                    <div className="font-medium">CHEQUE</div>
                    <div className="text-green-600 font-bold">
                      {(reportData?.sales?.cheque)?.toFixed(3) || 0}
                    </div>
                  </div> */}
                  <div>
                    <div className="font-medium">ONLINE TRANSFER</div>
                    <div className="text-green-600 font-bold">
                      {reportData?.sales?.online_payment?.toFixed(3) || 0}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section className="mb-3">
              <div className="flex justify-between items-center bg-gray-100 p-3 rounded-t">
                <h4 className="font-bold text-lg">SALES RETURN</h4>
                <div className="font-bold text-lg text-red-600">
                  {reportData?.salesReturn?.total?.toFixed(3) || 0}
                </div>
              </div>

              <div className="border border-t-0 rounded-b p-3">
                <div className="grid grid-cols-4 gap-4 text-center">
                  <div className="border-r">
                    <div className="font-medium">CASH</div>
                    <div className="text-red-600 font-bold">
                      {reportData?.salesReturn?.cash?.toFixed(3) || 0}
                    </div>
                  </div>
                  <div className="border-r">
                    <div className="font-medium">DEBIT / CREDIT CARD</div>
                    <div className="text-red-600 font-bold">
                      {(
                        reportData?.salesReturn?.debit_card +
                        reportData?.salesReturn?.credit_card
                      )?.toFixed(3) || 0}
                    </div>
                  </div>
                  <div className="border-r">
                    <div className="font-medium">BANK TRANSFER</div>
                    <div className="text-red-600 font-bold">
                      {reportData?.salesReturn?.bank_transfer?.toFixed(3) || 0}
                    </div>
                  </div>
                  {/* <div className="border-r">
                    <div className="font-medium">CHEQUE</div>
                    <div className="text-red-600 font-bold">
                      {(reportData?.salesReturn?.cheque)?.toFixed(3) || 0}
                    </div>
                  </div> */}
                  <div>
                    <div className="font-medium">ONLINE TRANSFER</div>
                    <div className="text-red-600 font-bold">
                      {reportData?.salesReturn?.online_payment?.toFixed(3) || 0}
                    </div>
                  </div>
                </div>
              </div>
            </section>

            <section>
              <div className="flex justify-between items-center bg-gray-100 p-3 rounded-t">
                <h4 className="font-bold text-lg">NET SALES</h4>
                <div className="font-bold text-lg text-blue-600">
                  {reportData?.netSales?.total?.toFixed(3) || 0}
                </div>
              </div>

              <div className="border border-t-0 rounded-b p-3">
                <div className="grid grid-cols-4 gap-4 text-center mb-1">
                  <div className="border-r">
                    <div className="font-medium">CASH</div>
                    <div className="text-blue-600 font-bold">
                      {reportData?.netSales?.cash?.toFixed(3) || 0}
                    </div>
                  </div>
                  <div className="border-r">
                    <div className="font-medium">DEBIT / CREDIT CARD</div>
                    <div className="text-blue-600 font-bold">
                      {(
                        reportData?.netSales?.debit_card +
                        reportData?.netSales?.credit_card
                      )?.toFixed(3) || 0}
                    </div>
                  </div>
                  <div className="border-r">
                    <div className="font-medium">BANK TRANSFER</div>
                    <div className="text-blue-600 font-bold">
                      {reportData?.netSales?.bank_transfer?.toFixed(3) || 0}
                    </div>
                  </div>
                  {/* <div className="border-r">
                      <div className="font-medium">CHEQUE</div>
                      <div className="text-blue-600 font-bold">
                        {(reportData?.netSales?.cheque)?.toFixed(3) || 0}
                      </div>
                    </div> */}
                  <div>
                    <div className="font-medium">ONLINE PAYMENT</div>
                    <div className="text-blue-600 font-bold">
                      {reportData?.netSales?.online_payment?.toFixed(3) || 0}
                    </div>
                  </div>
                </div>
              </div>

              <div className="border border-t-0 rounded-b p-3">
                <div className="grid grid-cols-2 gap-4 mb-1">
                  <div className="text-center border-r">
                    <div className="font-medium">SALES VAT</div>
                    <div className="text-blue-600 font-bold">
                      {reportData?.vat?.sales?.toFixed(3) || 0}
                    </div>
                  </div>
                  {/* <div className="text-center border-r">
                    <div className="font-medium">SALES RETURN VAT</div>
                    <div className="text-red-600 font-bold">
                      {(reportData?.vat?.returns)?.toFixed(3) || 0}
                    </div>
                  </div> */}
                  <div className="text-center">
                    <div className="font-medium">SALES DISCOUNT</div>
                    <div className="text-blue-600 font-bold">
                      {reportData?.discount?.sales?.toFixed(3) || 0}
                    </div>
                  </div>
                  {/* <div className="text-center">
                    <div className="font-medium">SALES RETURN DISCOUNT</div>
                    <div className="text-red-600 font-bold">
                      {(reportData?.discount?.returns)?.toFixed(3) || 0}
                    </div>
                  </div> */}
                </div>
              </div>

              <div className="border border-t-0 rounded-b p-3">
                <div className="grid grid-cols-2 gap-4 mb-1">
                  <div className="text-center">
                    <div className="font-medium">TOTAL SALES TRANSACTIONS</div>
                    <div className="text-lg font-bold">
                      {reportData?.totalTransactions.sales || 0}
                    </div>
                  </div>
                  <div className="text-center">
                    <div className="font-medium">
                      TOTAL SALES RETURN TRANSACTIONS
                    </div>
                    <div className="text-lg font-bold">
                      {reportData?.totalTransactions.returns || 0}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <div className="pt-4 pb-4">
            <div className="">
              {/* <div className="text-black-900 text-[0.65rem] text-center">
              <div className="text-center">
                {body?.branch?.image ? (
                  <div className="flex justify-center">
                    <div className="text-xl pb-2">
                      <img
                        className="w-[50px] h-[50px]"
                        src={`${URL}/uploads${body?.branch?.image}`}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="text-medium text-xl">{body?.branch?.name}</div>
                <div className="text-medium">{body?.branch?.category}</div>
              </div>
            </div>
            <div className="text-black-900 text-[0.65rem] text-center pt-4">
              <span>
                Email&nbsp;:&nbsp;
                {body?.branch?.email ? body?.branch?.email + ", " : ""}
                &nbsp;
              </span>
              <span>
                Phone&nbsp;:&nbsp;
                {body?.branch?.phone ? body?.branch?.phone : ""}
                &nbsp;
              </span>
              <div>
                {body?.branch?.area ? body?.branch?.area + ", " : ""}
                {body?.branch?.city ? body?.branch?.city + ", " : ""}
                {body?.branch?.country ? body?.branch?.country : ""}
              </div>
              <div>
                VATIN&nbsp;:&nbsp;
                {body?.branch?.tax ? body?.branch?.tax : "N/A"}
              </div>
            </div> */}
              <table
                className="w-full border overflow-hidden print-a4"
                ref={(el) => (componentRef = el)}
              >
                <thead>
                  <tr className="text-white bg-black border-b">
                    <td className="p-3">DESCRIPTION</td>
                    <td className="p-3 text-right">Total</td>
                  </tr>
                </thead>
                <tbody>
                  <tr className="border">
                    <td className="p-3">
                      <div className="text-medium">Sales</div>
                      <div className="pl-3 text-xs text-gray-500">
                        <div className="flex justify-between">
                          <div>Discount</div>
                          <div>-&nbsp;{body?.total_discount?.toFixed?.(3)}</div>
                        </div>
                        <div className="flex justify-between">
                          <div>CASH</div>
                          <div>+&nbsp;{body?.total_cash?.toFixed?.(3)}</div>
                        </div>
                        <div className="flex justify-between">
                          <div>DEBIT CARD</div>
                          <div>
                            +&nbsp;{body?.total_debit_card?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>BANK TRANSFER</div>
                          <div>
                            +&nbsp;{body?.total_bank_transfer?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CHEQUE</div>
                          <div>+&nbsp;{body?.total_cheque?.toFixed?.(3)}</div>
                        </div>
                        <div className="flex justify-between">
                          <div>CREDIT CARD</div>
                          <div>
                            +&nbsp;{body?.total_credit_card?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>ONLINE PAYMENT</div>
                          <div>
                            +&nbsp;{body?.total_online_payment?.toFixed?.(3)}
                          </div>
                        </div>
                        {/* <div className="flex justify-between">
                        <div>DELIVERY</div>
                        <div>+&nbsp;{body?.total_delivery?.toFixed?.(3)}</div>
                      </div>
                      <div className="flex justify-between">
                        <div>DISCOUNT</div>
                        <div>-&nbsp;{body?.total_discount?.toFixed?.(3)}</div>
                      </div> */}
                      </div>
                    </td>
                    <td className="p-3 border text-right align-bottom">
                      +&nbsp;{body?.total_sales.toFixed?.(3)}
                    </td>
                  </tr>
                  <tr className="border">
                    <td className="p-3">
                      <div className="text-medium">Sales Return</div>
                      <div className="pl-3 text-xs text-gray-500">
                        <div className="flex justify-between">
                          <div>CASH</div>
                          <div>
                            -&nbsp;
                            {body?.total_sales_returns_cash?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>DEBIT CARD</div>
                          <div>
                            -&nbsp;
                            {body?.total_sales_returns_debit_card?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>BANK TRANSFER</div>
                          <div>
                            -&nbsp;
                            {body?.total_sales_returns_bank_transfer?.toFixed?.(
                              3,
                            )}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CHEQUE</div>
                          <div>
                            -&nbsp;
                            {body?.total_sales_returns_cheque?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CREDIT CARD</div>
                          <div>
                            -&nbsp;
                            {body?.total_sales_returns_credit_card?.toFixed?.(
                              3,
                            )}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>ONLINE PAYMENT</div>
                          <div>
                            -&nbsp;
                            {body?.total_sales_returns_bank_transfer?.toFixed?.(
                              3,
                            )}
                          </div>
                        </div>

                        {/* <div className="flex justify-between">
                        <div>DELIVERY</div>
                        <div>
                          +&nbsp;
                          {body?.total_sales_returns_delivery?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div>DISCOUNT</div>
                        <div>
                          -&nbsp;
                          {body?.total_sales_returns_discount?.toFixed?.(3)}
                        </div>
                      </div> */}
                      </div>
                    </td>
                    <td className="p-3 border text-right align-bottom">
                      -&nbsp;{body?.total_sales_returns?.toFixed?.(3)}
                    </td>
                  </tr>
                  <tr className="border">
                    <td className="p-3">
                      <div className="text-medium">Purchases</div>
                      <div className="pl-3 text-xs text-gray-500">
                        <div className="flex justify-between">
                          <div>CASH</div>
                          <div>
                            -&nbsp;{body?.total_purchases_cash?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>DEBIT CARD</div>
                          <div>
                            -&nbsp;
                            {body?.total_purchases_debit_card?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>BANK TRANSFER</div>
                          <div>
                            -&nbsp;
                            {body?.total_purchases_bank_transfer?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CHEQUE</div>
                          <div>
                            -&nbsp;{body?.total_purchases_cheque?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CREDIT CARD</div>
                          <div>
                            -&nbsp;
                            {body?.total_purchases_credit_card?.toFixed?.(3)}
                          </div>
                        </div>

                        <div className="flex justify-between">
                          <div>ONLINE PAYMENT</div>
                          <div>
                            -&nbsp;
                            {body?.total_purchases_online_payment?.toFixed?.(3)}
                          </div>
                        </div>

                        {/* <div className="flex justify-between">
                        <div>DELIVERY</div>
                        <div>
                          +&nbsp;{body?.total_purchases_delivery?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div>DISCOUNT</div>
                        <div>
                          -&nbsp;{body?.total_purchases_discount?.toFixed?.(3)}
                        </div>
                      </div> */}
                      </div>
                    </td>
                    <td className="p-3 border text-right align-bottom">
                      -&nbsp;{body?.total_purchases?.toFixed?.(3)}
                    </td>
                  </tr>
                  <tr className="border">
                    <td className="p-3">
                      <div className="text-medium">Purchase Returns</div>
                      <div className="pl-3 text-xs text-gray-500">
                        <div className="flex justify-between">
                          <div>CASH</div>
                          <div>
                            +&nbsp;
                            {body?.total_purchase_return_cash?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>DEBIT CARD</div>
                          <div>
                            +&nbsp;
                            {body?.total_purchase_return_debit_card?.toFixed?.(
                              3,
                            )}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>BANK TRANSFER</div>
                          <div>
                            +&nbsp;
                            {body?.total_purchase_return_bank_transfer?.toFixed?.(
                              3,
                            )}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CHEQUE</div>
                          <div>
                            +&nbsp;
                            {body?.total_purchase_return_cheque?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CREDIT CARD</div>
                          <div>
                            +&nbsp;
                            {body?.total_purchase_return_credit_card?.toFixed?.(
                              3,
                            )}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>ONLINE PAYMENT</div>
                          <div>
                            +&nbsp;
                            {body?.total_purchases_online_payment?.toFixed?.(3)}
                          </div>
                        </div>

                        {/* <div className="flex justify-between">
                        <div>DELIVERY</div>
                        <div>
                          +&nbsp;
                          {body?.total_purchase_return_delivery?.toFixed?.(3)}
                        </div>
                      </div>
                      <div className="flex justify-between">
                        <div>DISCOUNT</div>
                        <div>
                          -&nbsp;
                          {body?.total_purchase_return_delivery?.toFixed?.(3)}
                        </div>
                      </div> */}
                      </div>
                    </td>
                    <td className="p-3 border text-right align-bottom">
                      +&nbsp;{body?.total_purchase_return?.toFixed?.(3)}
                    </td>
                  </tr>
                  <tr className="border">
                    <td className="border p-3">
                      <div className="text-medium">Expenses</div>
                      <div className="pl-3 text-xs text-gray-500">
                        <div className="flex justify-between">
                          <div>CASH</div>
                          <div>-&nbsp;{body?.total_expenses?.toFixed?.(3)}</div>
                        </div>
                        <div className="flex justify-between">
                          <div>DEBIT CARD</div>
                          <div>
                            -&nbsp;
                            {body?.total_expenses_debit_card?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>BANK TRANSFER</div>
                          <div>
                            -&nbsp;
                            {body?.total_expenses_bank_transfer?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CHEQUE</div>
                          <div>
                            -&nbsp;
                            {body?.total_expenses_return_cheque?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>CREDIT CARD</div>
                          <div>
                            -&nbsp;
                            {body?.total_expenses_credit_card?.toFixed?.(3)}
                          </div>
                        </div>
                        <div className="flex justify-between">
                          <div>ONLINE PAYMENT</div>
                          <div>
                            -&nbsp;
                            {body?.total_expenses_online_payment?.toFixed?.(3)}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="p-3 border text-right align-bottom">
                      -&nbsp;{body?.total_expenses?.toFixed?.(3)}
                    </td>
                  </tr>
                </tbody>
                <tbody>
                  <tr className="text-white bg-black border-b">
                    <td className="p-3">TOTAL</td>
                    <td className="p-3 text-right">
                      {body?.grand_total?.toFixed?.(3)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </ScrollWrapper>
      </Loadercomponent>
    </Header>
  );
};

export default Dashboard;
